export enum LeadTaskType {
  NotDefined = 0,
  ClientAgreement = 1,
  Proposal = 2,
  Dynamic = 3,
  ManuallyAdded = 4,
}
